const internalDeviceOutput = window.TCMS.viewtype;
const deviceOutput = window.TCMS.externalViewtype;
const event = internalDeviceOutput === 'desktop' ? 'mouseenter' : 'load';
const event2 = 'touchend'; // RECTSA-5045 - Wireframe hat ein preventDefault eingebaut, was den Click abfängt und auf tablet nur auf touchend hört. Daher hier doppelt
const selector = internalDeviceOutput === 'desktop' ? '#c24-header-top .c24-contact' : '.c24m-contact-wrapper';
let chattyInitExecuted = false;
const isApp = deviceOutput === 'app';

const contactContainer = document.querySelector(selector);

const controlServerAddressMapping = {
    de: {
        dev: 'https://api.chat.check24-test.de',
        int: 'https://api.chat.check24-test.de',
        staging: 'https://api.chat.check24-test.de',
        production: 'https://api.chat.check24.de'
    },
    at: {
        dev: 'https://api.chat.check24-test.de',
        int: 'https://api.chat.check24-test.de',
        staging: 'https://api.chat.check24-test.de',
        production: 'https://api.chat.check24.at'
    }
};

if (window?.Check24?.contact?.isContactLayerEnabled !== undefined) {
    window.Check24.contact.isContactLayerEnabled = false;
}

if (window?.C24M?.contact?.isContactLayerEnabled !== undefined) {
    window.C24M.contact.isContactLayerEnabled = false;
}

const locationSearch = location.search || null;
const urlSearchParams = new URLSearchParams(locationSearch);

function executeChattyInit() {
    if (chattyInitExecuted) {
        return;
    }

    chattyInitExecuted = true;

    let chatFlowName = 'pauschalreise.production';

    if (window.TCMS.env !== 'production') {
        chatFlowName = 'pauschalreise.prod-test';
    }

    import('./tcms_chatty.js')
        .then(({ chattyInit }) => {
            let options = {
                deviceoutput: deviceOutput,
                controlServerAddress:
                    controlServerAddressMapping[window.TCMS.language][window.TCMS.env] || 'https://api.chat.check24.de',
                chatFlowName: chatFlowName,
                chatFlowEntry: 'start_seo',
                contactLink: 'https://www.check24.de/unternehmen/kontakt/?sec=rsn',
                showButton: false
            };

            if (isApp) {
                options.useChatbotApp = true;
                options.presentationType = 'sheet';
                options.sheetState = 'half';
            }

            chattyInit(options);
        })
        .catch((err) => console.error(err));
}

const eventListener = (e) => {
    executeChattyInit();
};

if (contactContainer) {
    contactContainer.addEventListener(event2, eventListener, {
        once: true,
        passive: true,
        capture: true
    });

    contactContainer.addEventListener(event, eventListener, {
        once: true,
        passive: true,
        capture: true
    });
}

// init for ?showchat=1
if (urlSearchParams.get('showchat') === '1') {
    executeChattyInit();
}

/**
 * https://confluence.check24.de/display/C24APPS/JavaScript+Interface
 */
C24App.setSupportDialogHandler(() => {
    executeChattyInit();

    return true; // Return true prevent opening the default support dialog
});
